import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SearchResult, SearchType } from './types';

interface SearchState {
  results: SearchResult[] | null;
  selectedIndex: number | null;
  lastSearchedType: SearchType;
}

const initialState: SearchState = {
  results: null,
  selectedIndex: null,
  lastSearchedType: "Address"
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setResults: (state, action: PayloadAction<SearchResult[] | null>) => {
      state.results = action.payload;
    },
    setSelectedIndex: (state, action: PayloadAction<number | null>) => {
      state.selectedIndex = action.payload;
    },
    setLastSearchedType: (state, action: PayloadAction<SearchType>) => {
      state.lastSearchedType = action.payload;
    }
  },
});

export const { setResults, setSelectedIndex, setLastSearchedType } = searchSlice.actions;

export const selectResults = (state: RootState) => state.search.results;
export const selectSelectedIndex = (state: RootState) => state.search.selectedIndex;
export const selectLastSearchedType = (state: RootState) => state.search.lastSearchedType;

export default searchSlice.reducer;